const hexToPantone = [
  {'hex': '#F4ED7C', 'name': '100'},
  {'hex': '#F4ED47', 'name': '101'},
  {'hex': '#F9E814', 'name': '102'},
  {'hex': '#C6AD0F', 'name': '103'},
  {'hex': '#AD9B0C', 'name': '104'},
  {'hex': '#82750F', 'name': '105'},
  {'hex': '#F7E859', 'name': '106'},
  {'hex': '#F9E526', 'name': '107'},
  {'hex': '#F9DD16', 'name': '108'},
  {'hex': '#F9D616', 'name': '109'},
  {'hex': '#D8B511', 'name': '110'},
  {'hex': '#AA930A', 'name': '111'},
  {'hex': '#99840A', 'name': '112'},
  {'hex': '#F9E55B', 'name': '113'},
  {'hex': '#F9E24C', 'name': '114'},
  {'hex': '#F9E04C', 'name': '115'},
  {'hex': '#FCD116', 'name': '116'},
  {'hex': '#F7B50C', 'name': '116 2X'},
  {'hex': '#C6A00C', 'name': '117'},
  {'hex': '#AA8E0A', 'name': '118'},
  {'hex': '#897719', 'name': '119'},
  {'hex': '#F9E27F', 'name': '120'},
  {'hex': '#F7E8AA', 'name': '1205'},
  {'hex': '#F9E070', 'name': '121'},
  {'hex': '#F9E08C', 'name': '1215'},
  {'hex': '#FCD856', 'name': '122'},
  {'hex': '#FFCC49', 'name': '1225'},
  {'hex': '#FFC61E', 'name': '123'},
  {'hex': '#FCB514', 'name': '1235'},
  {'hex': '#E0AA0F', 'name': '124'},
  {'hex': '#BF910C', 'name': '1245'},
  {'hex': '#B58C0A', 'name': '125'},
  {'hex': '#A37F14', 'name': '1255'},
  {'hex': '#A38205', 'name': '126'},
  {'hex': '#7C6316', 'name': '1265'},
  {'hex': '#F4E287', 'name': '127'},
  {'hex': '#F4DB60', 'name': '128'},
  {'hex': '#F2D13D', 'name': '129'},
  {'hex': '#EAAF0F', 'name': '130'},
  {'hex': '#E29100', 'name': '130 2X'},
  {'hex': '#C6930A', 'name': '131'},
  {'hex': '#9E7C0A', 'name': '132'},
  {'hex': '#705B0A', 'name': '133'},
  {'hex': '#FFD87F', 'name': '134'},
  {'hex': '#FFD691', 'name': '1345'},
  {'hex': '#FCC963', 'name': '135'},
  {'hex': '#FCCE87', 'name': '1355'},
  {'hex': '#FCBF49', 'name': '136'},
  {'hex': '#FCBA5E', 'name': '1365'},
  {'hex': '#FCA311', 'name': '137'},
  {'hex': '#F99B0C', 'name': '1375'},
  {'hex': '#D88C02', 'name': '138'},
  {'hex': '#CC7A02', 'name': '1385'},
  {'hex': '#AF7505', 'name': '139'},
  {'hex': '#996007', 'name': '1395'},
  {'hex': '#7A5B11', 'name': '140'},
  {'hex': '#6B4714', 'name': '1405'},
  {'hex': '#F2CE68', 'name': '141'},
  {'hex': '#F2BF49', 'name': '142'},
  {'hex': '#EFB22D', 'name': '143'},
  {'hex': '#E28C05', 'name': '144'},
  {'hex': '#C67F07', 'name': '145'},
  {'hex': '#9E6B05', 'name': '146'},
  {'hex': '#725E26', 'name': '147'},
  {'hex': '#FFD69B', 'name': '148'},
  {'hex': '#FFB777', 'name': '1485'},
  {'hex': '#FCCC93', 'name': '149'},
  {'hex': '#FF993F', 'name': '1495'},
  {'hex': '#FCAD56', 'name': '150'},
  {'hex': '#F47C00', 'name': '1505'},
  {'hex': '#F77F00', 'name': '151'},
  {'hex': '#DD7500', 'name': '152'},
  {'hex': '#B55400', 'name': '1525'},
  {'hex': '#BC6D0A', 'name': '153'},
  {'hex': '#8C4400', 'name': '1535'},
  {'hex': '#995905', 'name': '154'},
  {'hex': '#4C280F', 'name': '1545'},
  {'hex': '#F4DBAA', 'name': '155'},
  {'hex': '#F9BF9E', 'name': '1555'},
  {'hex': '#F2C68C', 'name': '156'},
  {'hex': '#FCA577', 'name': '1565'},
  {'hex': '#EDA04F', 'name': '157'},
  {'hex': '#FC8744', 'name': '1575'},
  {'hex': '#E87511', 'name': '158'},
  {'hex': '#F96B07', 'name': '1585'},
  {'hex': '#C66005', 'name': '159'},
  {'hex': '#D15B05', 'name': '1595'},
  {'hex': '#9E540A', 'name': '160'},
  {'hex': '#A04F11', 'name': '1605'},
  {'hex': '#633A11', 'name': '161'},
  {'hex': '#843F0F', 'name': '1615'},
  {'hex': '#F9C6AA', 'name': '162'},
  {'hex': '#F9A58C', 'name': '1625'},
  {'hex': '#FC9E70', 'name': '163'},
  {'hex': '#F98E6D', 'name': '1635'},
  {'hex': '#FC7F3F', 'name': '164'},
  {'hex': '#F97242', 'name': '1645'},
  {'hex': '#F96302', 'name': '165'},
  {'hex': '#EA4F00', 'name': '165 2X'},
  {'hex': '#F95602', 'name': '1655'},
  {'hex': '#DD5900', 'name': '166'},
  {'hex': '#DD4F05', 'name': '1665'},
  {'hex': '#BC4F07', 'name': '167'},
  {'hex': '#A53F0F', 'name': '1675'},
  {'hex': '#6D3011', 'name': '168'},
  {'hex': '#843511', 'name': '1685'},
  {'hex': '#F9BAAA', 'name': '169'},
  {'hex': '#F98972', 'name': '170'},
  {'hex': '#F9603A', 'name': '171'},
  {'hex': '#F74902', 'name': '172'},
  {'hex': '#D14414', 'name': '173'},
  {'hex': '#933311', 'name': '174'},
  {'hex': '#6D3321', 'name': '175'},
  {'hex': '#F9AFAD', 'name': '176'},
  {'hex': '#F99EA3', 'name': '1765'},
  {'hex': '#F9B2B7', 'name': '1767'},
  {'hex': '#F9827F', 'name': '177'},
  {'hex': '#F9848E', 'name': '1775'},
  {'hex': '#FC6675', 'name': '1777'},
  {'hex': '#F95E59', 'name': '178'},
  {'hex': '#FC4F59', 'name': '1785'},
  {'hex': '#F43F4F', 'name': '1787'},
  {'hex': '#EF2B2D', 'name': '1788'},
  {'hex': '#D62100', 'name': '1788 2X'},
  {'hex': '#E23D28', 'name': '179'},
  {'hex': '#D62828', 'name': '1795'},
  {'hex': '#CC2D30', 'name': '1797'},
  {'hex': '#C13828', 'name': '180'},
  {'hex': '#AF2626', 'name': '1805'},
  {'hex': '#A03033', 'name': '1807'},
  {'hex': '#7C2D23', 'name': '181'},
  {'hex': '#7C211E', 'name': '1810'},
  {'hex': '#5B2D28', 'name': '1817'},
  {'hex': '#F9BFC1', 'name': '182'},
  {'hex': '#FC8C99', 'name': '183'},
  {'hex': '#FC5E72', 'name': '184'},
  {'hex': '#E8112D', 'name': '185'},
  {'hex': '#D11600', 'name': '185 2X'},
  {'hex': '#CE1126', 'name': '186'},
  {'hex': '#AF1E2D', 'name': '187'},
  {'hex': '#7C2128', 'name': '188'},
  {'hex': '#FFA3B2', 'name': '189'},
  {'hex': '#FCBFC9', 'name': '1895'},
  {'hex': '#FC758E', 'name': '190'},
  {'hex': '#FC9BB2', 'name': '1905'},
  {'hex': '#F4476B', 'name': '191'},
  {'hex': '#F4547C', 'name': '1915'},
  {'hex': '#E5053A', 'name': '192'},
  {'hex': '#E00747', 'name': '1925'},
  {'hex': '#DB828C', 'name': '193'},
  {'hex': '#C10538', 'name': '1935'},
  {'hex': '#992135', 'name': '194'},
  {'hex': '#A80C35', 'name': '1945'},
  {'hex': '#931638', 'name': '1955'},
  {'hex': '#F4C9C9', 'name': '196'},
  {'hex': '#EF99A3', 'name': '197'},
  {'hex': '#772D35', 'name': '198'},
  {'hex': '#D81C3F', 'name': '199'},
  {'hex': '#C41E3A', 'name': '200'},
  {'hex': '#A32638', 'name': '201'},
  {'hex': '#8C2633', 'name': '202'},
  {'hex': '#F2AFC1', 'name': '203'},
  {'hex': '#ED7A9E', 'name': '204'},
  {'hex': '#E54C7C', 'name': '205'},
  {'hex': '#D30547', 'name': '206'},
  {'hex': '#BAAA9E', 'name': '207'},
  {'hex': '#8E2344', 'name': '208'},
  {'hex': '#75263D', 'name': '209'},
  {'hex': '#FFA0BF', 'name': '210'},
  {'hex': '#FF77A8', 'name': '211'},
  {'hex': '#F94F8E', 'name': '212'},
  {'hex': '#EA0F6B', 'name': '213'},
  {'hex': '#CC0256', 'name': '214'},
  {'hex': '#A50544', 'name': '215'},
  {'hex': '#7C1E3F', 'name': '216'},
  {'hex': '#F4BFD1', 'name': '217'},
  {'hex': '#ED72AA', 'name': '218'},
  {'hex': '#E22882', 'name': '219'},
  {'hex': '#AA004F', 'name': '220'},
  {'hex': '#930042', 'name': '221'},
  {'hex': '#70193D', 'name': '222'},
  {'hex': '#F993C4', 'name': '223'},
  {'hex': '#F46BAF', 'name': '224'},
  {'hex': '#ED2893', 'name': '225'},
  {'hex': '#D60270', 'name': '226'},
  {'hex': '#AD005B', 'name': '227'},
  {'hex': '#8C004C', 'name': '228'},
  {'hex': '#6D213F', 'name': '229'},
  {'hex': '#FFA0CC', 'name': '230'},
  {'hex': '#FC70BA', 'name': '231'},
  {'hex': '#F43FA5', 'name': '232'},
  {'hex': '#CE007C', 'name': '233'},
  {'hex': '#AA0066', 'name': '234'},
  {'hex': '#8E0554', 'name': '235'},
  {'hex': '#F9AFD3', 'name': '236'},
  {'hex': '#F7C4D8', 'name': '2365'},
  {'hex': '#F484C4', 'name': '237'},
  {'hex': '#EA6BBF', 'name': '2375'},
  {'hex': '#ED4FAF', 'name': '238'},
  {'hex': '#DB28A5', 'name': '2385'},
  {'hex': '#E0219E', 'name': '239'},
  {'hex': '#C4057C', 'name': '239 2X'},
  {'hex': '#C4008C', 'name': '2395'},
  {'hex': '#C40F89', 'name': '240'},
  {'hex': '#A8007A', 'name': '2405'},
  {'hex': '#AD0075', 'name': '241'},
  {'hex': '#9B0070', 'name': '2415'},
  {'hex': '#7C1C51', 'name': '242'},
  {'hex': '#87005B', 'name': '2425'},
  {'hex': '#F2BAD8', 'name': '243'},
  {'hex': '#EDA0D3', 'name': '244'},
  {'hex': '#E87FC9', 'name': '245'},
  {'hex': '#CC00A0', 'name': '246'},
  {'hex': '#B7008E', 'name': '247'},
  {'hex': '#A3057F', 'name': '248'},
  {'hex': '#7F2860', 'name': '249'},
  {'hex': '#EDC4DD', 'name': '250'},
  {'hex': '#E29ED6', 'name': '251'},
  {'hex': '#D36BC6', 'name': '252'},
  {'hex': '#AF23A5', 'name': '253'},
  {'hex': '#A02D96', 'name': '254'},
  {'hex': '#772D6B', 'name': '255'},
  {'hex': '#E5C4D6', 'name': '256'},
  {'hex': '#D8A8D8', 'name': '2562'},
  {'hex': '#D1A0CC', 'name': '2563'},
  {'hex': '#BF93CC', 'name': '2567'},
  {'hex': '#D3A5C9', 'name': '257'},
  {'hex': '#C687D1', 'name': '2572'},
  {'hex': '#BA7CBC', 'name': '2573'},
  {'hex': '#AA72BF', 'name': '2577'},
  {'hex': '#9B4F96', 'name': '258'},
  {'hex': '#AA47BA', 'name': '2582'},
  {'hex': '#9E4FA5', 'name': '2583'},
  {'hex': '#8E47AD', 'name': '2587'},
  {'hex': '#72166B', 'name': '259'},
  {'hex': '#930FA5', 'name': '2592'},
  {'hex': '#720082', 'name': '2592 2X'},
  {'hex': '#872B93', 'name': '2593'},
  {'hex': '#66008C', 'name': '2597'},
  {'hex': '#681E5B', 'name': '260'},
  {'hex': '#820C8E', 'name': '2602'},
  {'hex': '#70147A', 'name': '2603'},
  {'hex': '#5B027A', 'name': '2607'},
  {'hex': '#5E2154', 'name': '261'},
  {'hex': '#701E72', 'name': '2612'},
  {'hex': '#66116D', 'name': '2613'},
  {'hex': '#560C70', 'name': '2617'},
  {'hex': '#542344', 'name': '262'},
  {'hex': '#602D59', 'name': '2622'},
  {'hex': '#5B195E', 'name': '2623'},
  {'hex': '#4C145E', 'name': '2627'},
  {'hex': '#E0CEE0', 'name': '263'},
  {'hex': '#C9ADD8', 'name': '2635'},
  {'hex': '#C6AADB', 'name': '264'},
  {'hex': '#B591D1', 'name': '2645'},
  {'hex': '#9663C4', 'name': '265'},
  {'hex': '#9B6DC6', 'name': '2655'},
  {'hex': '#6D28AA', 'name': '266'},
  {'hex': '#894FBF', 'name': '2665'},
  {'hex': '#59118E', 'name': '267'},
  {'hex': '#4F2170', 'name': '268'},
  {'hex': '#56008C', 'name': '2685'},
  {'hex': '#442359', 'name': '269'},
  {'hex': '#44235E', 'name': '2695'},
  {'hex': '#BAAFD3', 'name': '270'},
  {'hex': '#AD9ED3', 'name': '2705'},
  {'hex': '#D1CEDD', 'name': '2706'},
  {'hex': '#BFD1E5', 'name': '2707'},
  {'hex': '#AFBCDB', 'name': '2708'},
  {'hex': '#9E91C6', 'name': '271'},
  {'hex': '#937ACC', 'name': '2715'},
  {'hex': '#A5A0D6', 'name': '2716'},
  {'hex': '#A5BAE0', 'name': '2717'},
  {'hex': '#5B77CC', 'name': '2718'},
  {'hex': '#8977BA', 'name': '272'},
  {'hex': '#7251BC', 'name': '2725'},
  {'hex': '#6656BC', 'name': '2726'},
  {'hex': '#5E68C4', 'name': '2727'},
  {'hex': '#3044B5', 'name': '2728'},
  {'hex': '#38197A', 'name': '273'},
  {'hex': '#4F0093', 'name': '2735'},
  {'hex': '#4930AD', 'name': '2736'},
  {'hex': '#2D008E', 'name': '2738'},
  {'hex': '#2B1166', 'name': '274'},
  {'hex': '#3F0077', 'name': '2745'},
  {'hex': '#3F2893', 'name': '2746'},
  {'hex': '#1C146B', 'name': '2747'},
  {'hex': '#1E1C77', 'name': '2748'},
  {'hex': '#260F54', 'name': '275'},
  {'hex': '#35006D', 'name': '2755'},
  {'hex': '#332875', 'name': '2756'},
  {'hex': '#141654', 'name': '2757'},
  {'hex': '#192168', 'name': '2758'},
  {'hex': '#2B2147', 'name': '276'},
  {'hex': '#2B0C56', 'name': '2765'},
  {'hex': '#2B265B', 'name': '2766'},
  {'hex': '#14213D', 'name': '2767'},
  {'hex': '#112151', 'name': '2768'},
  {'hex': '#B5D1E8', 'name': '277'},
  {'hex': '#99BADD', 'name': '278'},
  {'hex': '#6689CC', 'name': '279'},
  {'hex': '#002B7F', 'name': '280'},
  {'hex': '#002868', 'name': '281'},
  {'hex': '#002654', 'name': '282'},
  {'hex': '#9BC4E2', 'name': '283'},
  {'hex': '#75AADB', 'name': '284'},
  {'hex': '#3A75C4', 'name': '285'},
  {'hex': '#0038A8', 'name': '286'},
  {'hex': '#003893', 'name': '287'},
  {'hex': '#00337F', 'name': '288'},
  {'hex': '#002649', 'name': '289'},
  {'hex': '#C4D8E2', 'name': '290'},
  {'hex': '#93C6E0', 'name': '2905'},
  {'hex': '#A8CEE2', 'name': '291'},
  {'hex': '#60AFDD', 'name': '2915'},
  {'hex': '#75B2DD', 'name': '292'},
  {'hex': '#008ED6', 'name': '2925'},
  {'hex': '#0051BA', 'name': '293'},
  {'hex': '#005BBF', 'name': '2935'},
  {'hex': '#003F87', 'name': '294'},
  {'hex': '#0054A0', 'name': '2945'},
  {'hex': '#00386B', 'name': '295'},
  {'hex': '#003D6B', 'name': '2955'},
  {'hex': '#002D47', 'name': '296'},
  {'hex': '#00334C', 'name': '2965'},
  {'hex': '#82C6E2', 'name': '297'},
  {'hex': '#BAE0E2', 'name': '2975'},
  {'hex': '#51B5E0', 'name': '298'},
  {'hex': '#51BFE2', 'name': '2985'},
  {'hex': '#00A3DD', 'name': '299'},
  {'hex': '#007FCC', 'name': '299 2X'},
  {'hex': '#00A5DB', 'name': '2995'},
  {'hex': '#0072C6', 'name': '300'},
  {'hex': '#0084C9', 'name': '3005'},
  {'hex': '#005B99', 'name': '301'},
  {'hex': '#00709E', 'name': '3015'},
  {'hex': '#004F6D', 'name': '302'},
  {'hex': '#00546B', 'name': '3025'},
  {'hex': '#003F54', 'name': '303'},
  {'hex': '#004454', 'name': '3035'},
  {'hex': '#A5DDE2', 'name': '304'},
  {'hex': '#70CEE2', 'name': '305'},
  {'hex': '#00BCE2', 'name': '306'},
  {'hex': '#00A3D1', 'name': '306 2X'},
  {'hex': '#007AA5', 'name': '307'},
  {'hex': '#00607C', 'name': '308'},
  {'hex': '#003F49', 'name': '309'},
  {'hex': '#72D1DD', 'name': '310'},
  {'hex': '#7FD6DB', 'name': '3105'},
  {'hex': '#28C4D8', 'name': '311'},
  {'hex': '#2DC6D6', 'name': '3115'},
  {'hex': '#00ADC6', 'name': '312'},
  {'hex': '#00B7C6', 'name': '3125'},
  {'hex': '#0099B5', 'name': '313'},
  {'hex': '#009BAA', 'name': '3135'},
  {'hex': '#00829B', 'name': '314'},
  {'hex': '#00848E', 'name': '3145'},
  {'hex': '#006B77', 'name': '315'},
  {'hex': '#006D75', 'name': '3155'},
  {'hex': '#00494F', 'name': '316'},
  {'hex': '#00565B', 'name': '3165'},
  {'hex': '#C9E8DD', 'name': '317'},
  {'hex': '#93DDDB', 'name': '318'},
  {'hex': '#4CCED1', 'name': '319'},
  {'hex': '#009EA0', 'name': '320'},
  {'hex': '#007F82', 'name': '320 2X'},
  {'hex': '#008789', 'name': '321'},
  {'hex': '#007272', 'name': '322'},
  {'hex': '#006663', 'name': '323'},
  {'hex': '#AADDD6', 'name': '324'},
  {'hex': '#87DDD1', 'name': '3242'},
  {'hex': '#8CE0D1', 'name': '3245'},
  {'hex': '#7AD3C1', 'name': '3248'},
  {'hex': '#56C9C1', 'name': '325'},
  {'hex': '#56D6C9', 'name': '3252'},
  {'hex': '#47D6C1', 'name': '3255'},
  {'hex': '#35C4AF', 'name': '3258'},
  {'hex': '#00B2AA', 'name': '326'},
  {'hex': '#00C1B5', 'name': '3262'},
  {'hex': '#00C6B2', 'name': '3265'},
  {'hex': '#00AF99', 'name': '3268'},
  {'hex': '#008C82', 'name': '327'},
  {'hex': '#008977', 'name': '327 2X'},
  {'hex': '#00AA9E', 'name': '3272'},
  {'hex': '#00B2A0', 'name': '3275'},
  {'hex': '#009B84', 'name': '3278'},
  {'hex': '#007770', 'name': '328'},
  {'hex': '#008C82', 'name': '3282'},
  {'hex': '#009987', 'name': '3285'},
  {'hex': '#008270', 'name': '3288'},
  {'hex': '#006D66', 'name': '329'},
  {'hex': '#006056', 'name': '3292'},
  {'hex': '#008272', 'name': '3295'},
  {'hex': '#006B5B', 'name': '3298'},
  {'hex': '#005951', 'name': '330'},
  {'hex': '#00493F', 'name': '3302'},
  {'hex': '#004F42', 'name': '3305'},
  {'hex': '#004438', 'name': '3308'},
  {'hex': '#BAEAD6', 'name': '331'},
  {'hex': '#A0E5CE', 'name': '332'},
  {'hex': '#5EDDC1', 'name': '333'},
  {'hex': '#00997C', 'name': '334'},
  {'hex': '#007C66', 'name': '335'},
  {'hex': '#006854', 'name': '336'},
  {'hex': '#9BDBC1', 'name': '337'},
  {'hex': '#8EE2BC', 'name': '3375'},
  {'hex': '#7AD1B5', 'name': '338'},
  {'hex': '#54D8A8', 'name': '3385'},
  {'hex': '#00B28C', 'name': '339'},
  {'hex': '#00C993', 'name': '3395'},
  {'hex': '#009977', 'name': '340'},
  {'hex': '#00B27A', 'name': '3405'},
  {'hex': '#007A5E', 'name': '341'},
  {'hex': '#007C59', 'name': '3415'},
  {'hex': '#006B54', 'name': '342'},
  {'hex': '#006847', 'name': '3425'},
  {'hex': '#00563F', 'name': '343'},
  {'hex': '#024930', 'name': '3435'},
  {'hex': '#B5E2BF', 'name': '344'},
  {'hex': '#96D8AF', 'name': '345'},
  {'hex': '#70CE9B', 'name': '346'},
  {'hex': '#009E60', 'name': '347'},
  {'hex': '#008751', 'name': '348'},
  {'hex': '#006B3F', 'name': '349'},
  {'hex': '#234F33', 'name': '350'},
  {'hex': '#B5E8BF', 'name': '351'},
  {'hex': '#99E5B2', 'name': '352'},
  {'hex': '#84E2A8', 'name': '353'},
  {'hex': '#00B760', 'name': '354'},
  {'hex': '#009E49', 'name': '355'},
  {'hex': '#007A3D', 'name': '356'},
  {'hex': '#215B33', 'name': '357'},
  {'hex': '#AADD96', 'name': '358'},
  {'hex': '#A0DB8E', 'name': '359'},
  {'hex': '#60C659', 'name': '360'},
  {'hex': '#1EB53A', 'name': '361'},
  {'hex': '#339E35', 'name': '362'},
  {'hex': '#3D8E33', 'name': '363'},
  {'hex': '#3A7728', 'name': '364'},
  {'hex': '#D3E8A3', 'name': '365'},
  {'hex': '#C4E58E', 'name': '366'},
  {'hex': '#AADD6D', 'name': '367'},
  {'hex': '#5BBF21', 'name': '368'},
  {'hex': '#009E0F', 'name': '368 2X'},
  {'hex': '#56AA1C', 'name': '369'},
  {'hex': '#568E14', 'name': '370'},
  {'hex': '#566B21', 'name': '371'},
  {'hex': '#D8ED96', 'name': '372'},
  {'hex': '#CEEA82', 'name': '373'},
  {'hex': '#BAE860', 'name': '374'},
  {'hex': '#8CD600', 'name': '375'},
  {'hex': '#54BC00', 'name': '375 2X'},
  {'hex': '#7FBA00', 'name': '376'},
  {'hex': '#709302', 'name': '377'},
  {'hex': '#566314', 'name': '378'},
  {'hex': '#E0EA68', 'name': '379'},
  {'hex': '#D6E542', 'name': '380'},
  {'hex': '#CCE226', 'name': '381'},
  {'hex': '#BAD80A', 'name': '382'},
  {'hex': '#9EC400', 'name': '382 2X'},
  {'hex': '#A3AF07', 'name': '383'},
  {'hex': '#939905', 'name': '384'},
  {'hex': '#707014', 'name': '385'},
  {'hex': '#E8ED60', 'name': '386'},
  {'hex': '#E0ED44', 'name': '387'},
  {'hex': '#D6E80F', 'name': '388'},
  {'hex': '#CEE007', 'name': '389'},
  {'hex': '#BAC405', 'name': '390'},
  {'hex': '#9E9E07', 'name': '391'},
  {'hex': '#848205', 'name': '392'},
  {'hex': '#F2EF87', 'name': '393'},
  {'hex': '#F2ED6D', 'name': '3935'},
  {'hex': '#EAED35', 'name': '394'},
  {'hex': '#EFEA07', 'name': '3945'},
  {'hex': '#E5E811', 'name': '395'},
  {'hex': '#EDE211', 'name': '3955'},
  {'hex': '#E0E20C', 'name': '396'},
  {'hex': '#E8DD11', 'name': '3965'},
  {'hex': '#C1BF0A', 'name': '397'},
  {'hex': '#B5A80C', 'name': '3975'},
  {'hex': '#AFA80A', 'name': '398'},
  {'hex': '#998C0A', 'name': '3985'},
  {'hex': '#998E07', 'name': '399'},
  {'hex': '#6D6002', 'name': '3995'},
  {'hex': '#D1C6B5', 'name': '400'},
  {'hex': '#C1B5A5', 'name': '401'},
  {'hex': '#AFA593', 'name': '402'},
  {'hex': '#998C7C', 'name': '403'},
  {'hex': '#827566', 'name': '404'},
  {'hex': '#6B5E4F', 'name': '405'},
  {'hex': '#CEC1B5', 'name': '406'},
  {'hex': '#A8998C', 'name': '408'},
  {'hex': '#99897C', 'name': '409'},
  {'hex': '#7C6D63', 'name': '410'},
  {'hex': '#66594C', 'name': '411'},
  {'hex': '#3D3028', 'name': '412'},
  {'hex': '#C6C1B2', 'name': '413'},
  {'hex': '#B5AFA0', 'name': '414'},
  {'hex': '#A39E8C', 'name': '415'},
  {'hex': '#8E8C7A', 'name': '416'},
  {'hex': '#777263', 'name': '417'},
  {'hex': '#605E4F', 'name': '418'},
  {'hex': '#282821', 'name': '419'},
  {'hex': '#D1CCBF', 'name': '420'},
  {'hex': '#BFBAAF', 'name': '421'},
  {'hex': '#AFAAA3', 'name': '422'},
  {'hex': '#96938E', 'name': '423'},
  {'hex': '#827F77', 'name': '424'},
  {'hex': '#60605B', 'name': '425'},
  {'hex': '#2B2B28', 'name': '426'},
  {'hex': '#DDDBD1', 'name': '427'},
  {'hex': '#D1CEC6', 'name': '428'},
  {'hex': '#ADAFAA', 'name': '429'},
  {'hex': '#919693', 'name': '430'},
  {'hex': '#666D70', 'name': '431'},
  {'hex': '#444F51', 'name': '432'},
  {'hex': '#30383A', 'name': '433'},
  {'hex': '#0A0C11', 'name': '433 2X'},
  {'hex': '#E0D1C6', 'name': '434'},
  {'hex': '#D3BFB7', 'name': '435'},
  {'hex': '#BCA59E', 'name': '436'},
  {'hex': '#8C706B', 'name': '437'},
  {'hex': '#593F3D', 'name': '438'},
  {'hex': '#493533', 'name': '439'},
  {'hex': '#3F302B', 'name': '440'},
  {'hex': '#D1D1C6', 'name': '441'},
  {'hex': '#BABFB7', 'name': '442'},
  {'hex': '#A3A8A3', 'name': '443'},
  {'hex': '#898E8C', 'name': '444'},
  {'hex': '#565959', 'name': '445'},
  {'hex': '#494C49', 'name': '446'},
  {'hex': '#3F3F38', 'name': '447'},
  {'hex': '#54472D', 'name': '448'},
  {'hex': '#604C11', 'name': '4485'},
  {'hex': '#544726', 'name': '449'},
  {'hex': '#877530', 'name': '4495'},
  {'hex': '#60542B', 'name': '450'},
  {'hex': '#A09151', 'name': '4505'},
  {'hex': '#ADA07A', 'name': '451'},
  {'hex': '#BCAD75', 'name': '4515'},
  {'hex': '#C4B796', 'name': '452'},
  {'hex': '#009944', 'name': '452 2X'},
  {'hex': '#CCBF8E', 'name': '4525'},
  {'hex': '#D6CCAF', 'name': '453'},
  {'hex': '#DBCEA5', 'name': '4535'},
  {'hex': '#E2D8BF', 'name': '454'},
  {'hex': '#E5DBBA', 'name': '4545'},
  {'hex': '#665614', 'name': '455'},
  {'hex': '#998714', 'name': '456'},
  {'hex': '#B59B0C', 'name': '457'},
  {'hex': '#DDCC6B', 'name': '458'},
  {'hex': '#E2D67C', 'name': '459'},
  {'hex': '#EADD96', 'name': '460'},
  {'hex': '#EDE5AD', 'name': '461'},
  {'hex': '#5B4723', 'name': '462'},
  {'hex': '#472311', 'name': '4625'},
  {'hex': '#755426', 'name': '463'},
  {'hex': '#8C5933', 'name': '4635'},
  {'hex': '#876028', 'name': '464'},
  {'hex': '#704214', 'name': '464 2X'},
  {'hex': '#B28260', 'name': '4645'},
  {'hex': '#C1A875', 'name': '465'},
  {'hex': '#C49977', 'name': '4655'},
  {'hex': '#D1BF91', 'name': '466'},
  {'hex': '#D8B596', 'name': '4665'},
  {'hex': '#DDCCA5', 'name': '467'},
  {'hex': '#E5C6AA', 'name': '4675'},
  {'hex': '#E2D6B5', 'name': '468'},
  {'hex': '#EDD3BC', 'name': '4685'},
  {'hex': '#603311', 'name': '469'},
  {'hex': '#51261C', 'name': '4695'},
  {'hex': '#9B4F19', 'name': '470'},
  {'hex': '#7C513D', 'name': '4705'},
  {'hex': '#BC5E1E', 'name': '471'},
  {'hex': '#A34402', 'name': '471 2X'},
  {'hex': '#99705B', 'name': '4715'},
  {'hex': '#EAAA7A', 'name': '472'},
  {'hex': '#B5917C', 'name': '4725'},
  {'hex': '#F4C4A0', 'name': '473'},
  {'hex': '#CCAF9B', 'name': '4735'},
  {'hex': '#F4CCAA', 'name': '474'},
  {'hex': '#D8BFAA', 'name': '4745'},
  {'hex': '#F7D3B5', 'name': '475'},
  {'hex': '#E2CCBA', 'name': '4755'},
  {'hex': '#593D2B', 'name': '476'},
  {'hex': '#633826', 'name': '477'},
  {'hex': '#7A3F28', 'name': '478'},
  {'hex': '#AF8970', 'name': '479'},
  {'hex': '#D3B7A3', 'name': '480'},
  {'hex': '#E0CCBA', 'name': '481'},
  {'hex': '#E5D3C1', 'name': '482'},
  {'hex': '#6B3021', 'name': '483'},
  {'hex': '#9B301C', 'name': '484'},
  {'hex': '#D81E05', 'name': '485'},
  {'hex': '#CC0C00', 'name': '485 2X'},
  {'hex': '#ED9E84', 'name': '486'},
  {'hex': '#EFB5A0', 'name': '487'},
  {'hex': '#F2C4AF', 'name': '488'},
  {'hex': '#F2D1BF', 'name': '489'},
  {'hex': '#5B2626', 'name': '490'},
  {'hex': '#752828', 'name': '491'},
  {'hex': '#913338', 'name': '492'},
  {'hex': '#F2ADB2', 'name': '494'},
  {'hex': '#F4BCBF', 'name': '495'},
  {'hex': '#F7C9C6', 'name': '496'},
  {'hex': '#512826', 'name': '497'},
  {'hex': '#441E1C', 'name': '4975'},
  {'hex': '#6D332B', 'name': '498'},
  {'hex': '#844949', 'name': '4985'},
  {'hex': '#7A382D', 'name': '499'},
  {'hex': '#A56B6D', 'name': '4995'},
  {'hex': '#CE898C', 'name': '500'},
  {'hex': '#BC8787', 'name': '5005'},
  {'hex': '#EAB2B2', 'name': '501'},
  {'hex': '#D8ADA8', 'name': '5015'},
  {'hex': '#F2C6C4', 'name': '502'},
  {'hex': '#E2BCB7', 'name': '5025'},
  {'hex': '#F4D1CC', 'name': '503'},
  {'hex': '#EDCEC6', 'name': '5035'},
  {'hex': '#511E26', 'name': '504'},
  {'hex': '#661E2B', 'name': '505'},
  {'hex': '#7A2638', 'name': '506'},
  {'hex': '#D8899B', 'name': '507'},
  {'hex': '#E8A5AF', 'name': '508'},
  {'hex': '#F2BABF', 'name': '509'},
  {'hex': '#F4C6C9', 'name': '510'},
  {'hex': '#602144', 'name': '511'},
  {'hex': '#4F213A', 'name': '5115'},
  {'hex': '#84216B', 'name': '512'},
  {'hex': '#754760', 'name': '5125'},
  {'hex': '#9E2387', 'name': '513'},
  {'hex': '#936B7F', 'name': '5135'},
  {'hex': '#D884BC', 'name': '514'},
  {'hex': '#AD8799', 'name': '5145'},
  {'hex': '#E8A3C9', 'name': '515'},
  {'hex': '#CCAFB7', 'name': '5155'},
  {'hex': '#F2BAD3', 'name': '516'},
  {'hex': '#E0C9CC', 'name': '5165'},
  {'hex': '#F4CCD8', 'name': '517'},
  {'hex': '#E8D6D1', 'name': '5175'},
  {'hex': '#512D44', 'name': '518'},
  {'hex': '#472835', 'name': '5185'},
  {'hex': '#63305E', 'name': '519'},
  {'hex': '#593344', 'name': '5195'},
  {'hex': '#703572', 'name': '520'},
  {'hex': '#8E6877', 'name': '5205'},
  {'hex': '#B58CB2', 'name': '521'},
  {'hex': '#B5939B', 'name': '5215'},
  {'hex': '#C6A3C1', 'name': '522'},
  {'hex': '#CCADAF', 'name': '5225'},
  {'hex': '#D3B7CC', 'name': '523'},
  {'hex': '#DDC6C4', 'name': '5235'},
  {'hex': '#E2CCD3', 'name': '524'},
  {'hex': '#E5D3CC', 'name': '5245'},
  {'hex': '#512654', 'name': '525'},
  {'hex': '#35264F', 'name': '5255'},
  {'hex': '#68217A', 'name': '526'},
  {'hex': '#493D63', 'name': '5265'},
  {'hex': '#7A1E99', 'name': '527'},
  {'hex': '#605677', 'name': '5275'},
  {'hex': '#AF72C1', 'name': '528'},
  {'hex': '#8C8299', 'name': '5285'},
  {'hex': '#CEA3D3', 'name': '529'},
  {'hex': '#B2A8B5', 'name': '5295'},
  {'hex': '#D6AFD6', 'name': '530'},
  {'hex': '#CCC1C6', 'name': '5305'},
  {'hex': '#E5C6DB', 'name': '531'},
  {'hex': '#DBD3D3', 'name': '5315'},
  {'hex': '#353842', 'name': '532'},
  {'hex': '#353F5B', 'name': '533'},
  {'hex': '#3A4972', 'name': '534'},
  {'hex': '#9BA3B7', 'name': '535'},
  {'hex': '#ADB2C1', 'name': '536'},
  {'hex': '#C4C6CE', 'name': '537'},
  {'hex': '#D6D3D6', 'name': '538'},
  {'hex': '#003049', 'name': '539'},
  {'hex': '#02283A', 'name': '5395'},
  {'hex': '#00335B', 'name': '540'},
  {'hex': '#3F6075', 'name': '5405'},
  {'hex': '#003F77', 'name': '541'},
  {'hex': '#607C8C', 'name': '5415'},
  {'hex': '#6693BC', 'name': '542'},
  {'hex': '#8499A5', 'name': '5425'},
  {'hex': '#93B7D1', 'name': '543'},
  {'hex': '#AFBCBF', 'name': '5435'},
  {'hex': '#B7CCDB', 'name': '544'},
  {'hex': '#C4CCCC', 'name': '5445'},
  {'hex': '#C4D3DD', 'name': '545'},
  {'hex': '#D6D8D3', 'name': '5455'},
  {'hex': '#0C3844', 'name': '546'},
  {'hex': '#00353A', 'name': '5463'},
  {'hex': '#193833', 'name': '5467'},
  {'hex': '#003F54', 'name': '547'},
  {'hex': '#26686D', 'name': '5473'},
  {'hex': '#3A564F', 'name': '5477'},
  {'hex': '#004459', 'name': '548'},
  {'hex': '#609191', 'name': '5483'},
  {'hex': '#667C72', 'name': '5487'},
  {'hex': '#5E99AA', 'name': '549'},
  {'hex': '#8CAFAD', 'name': '5493'},
  {'hex': '#91A399', 'name': '5497'},
  {'hex': '#87AFBF', 'name': '550'},
  {'hex': '#AAC4BF', 'name': '5503'},
  {'hex': '#AFBAB2', 'name': '5507'},
  {'hex': '#A3C1C9', 'name': '551'},
  {'hex': '#CED8D1', 'name': '5513'},
  {'hex': '#C9CEC4', 'name': '5517'},
  {'hex': '#C4D6D6', 'name': '552'},
  {'hex': '#D6DDD6', 'name': '5523'},
  {'hex': '#CED1C6', 'name': '5527'},
  {'hex': '#234435', 'name': '553'},
  {'hex': '#213D30', 'name': '5535'},
  {'hex': '#195E47', 'name': '554'},
  {'hex': '#4F6D5E', 'name': '5545'},
  {'hex': '#076D54', 'name': '555'},
  {'hex': '#779182', 'name': '5555'},
  {'hex': '#7AA891', 'name': '556'},
  {'hex': '#96AA99', 'name': '5565'},
  {'hex': '#A3C1AD', 'name': '557'},
  {'hex': '#AFBFAD', 'name': '5575'},
  {'hex': '#B7CEBC', 'name': '558'},
  {'hex': '#C4CEBF', 'name': '5585'},
  {'hex': '#C6D6C4', 'name': '559'},
  {'hex': '#D8DBCC', 'name': '5595'},
  {'hex': '#2B4C3F', 'name': '560'},
  {'hex': '#233A2D', 'name': '5605'},
  {'hex': '#266659', 'name': '561'},
  {'hex': '#546856', 'name': '5615'},
  {'hex': '#1E7A6D', 'name': '562'},
  {'hex': '#728470', 'name': '5625'},
  {'hex': '#7FBCAA', 'name': '563'},
  {'hex': '#9EAA99', 'name': '5635'},
  {'hex': '#05705E', 'name': '564'},
  {'hex': '#BCC1B2', 'name': '5645'},
  {'hex': '#BCDBCC', 'name': '565'},
  {'hex': '#C6CCBA', 'name': '5655'},
  {'hex': '#D1E2D3', 'name': '566'},
  {'hex': '#D6D6C6', 'name': '5665'},
  {'hex': '#265142', 'name': '567'},
  {'hex': '#008772', 'name': '569'},
  {'hex': '#7FC6B2', 'name': '570'},
  {'hex': '#AADBC6', 'name': '571'},
  {'hex': '#BCE2CE', 'name': '572'},
  {'hex': '#CCE5D6', 'name': '573'},
  {'hex': '#495928', 'name': '574'},
  {'hex': '#3F4926', 'name': '5743'},
  {'hex': '#424716', 'name': '5747'},
  {'hex': '#547730', 'name': '575'},
  {'hex': '#5E663A', 'name': '5753'},
  {'hex': '#6B702B', 'name': '5757'},
  {'hex': '#608E3A', 'name': '576'},
  {'hex': '#777C4F', 'name': '5763'},
  {'hex': '#8C914F', 'name': '5767'},
  {'hex': '#B5CC8E', 'name': '577'},
  {'hex': '#9B9E72', 'name': '5773'},
  {'hex': '#AAAD75', 'name': '5777'},
  {'hex': '#C6D6A0', 'name': '578'},
  {'hex': '#B5B58E', 'name': '5783'},
  {'hex': '#C6C699', 'name': '5787'},
  {'hex': '#C9D6A3', 'name': '579'},
  {'hex': '#C6C6A5', 'name': '5793'},
  {'hex': '#D3D1AA', 'name': '5797'},
  {'hex': '#D8DDB5', 'name': '580'},
  {'hex': '#D8D6B7', 'name': '5803'},
  {'hex': '#E0DDBC', 'name': '5807'},
  {'hex': '#605E11', 'name': '581'},
  {'hex': '#494411', 'name': '5815'},
  {'hex': '#878905', 'name': '582'},
  {'hex': '#75702B', 'name': '5825'},
  {'hex': '#AABA0A', 'name': '583'},
  {'hex': '#9E9959', 'name': '5835'},
  {'hex': '#CED649', 'name': '584'},
  {'hex': '#B2AA70', 'name': '5845'},
  {'hex': '#DBE06B', 'name': '585'},
  {'hex': '#CCC693', 'name': '5855'},
  {'hex': '#E2E584', 'name': '586'},
  {'hex': '#D6CEA3', 'name': '5865'},
  {'hex': '#E8E89B', 'name': '587'},
  {'hex': '#E0DBB5', 'name': '5875'},
  {'hex': '#F4EDAF', 'name': '600'},
  {'hex': '#F2ED9E', 'name': '601'},
  {'hex': '#F2EA87', 'name': '602'},
  {'hex': '#EDE85B', 'name': '603'},
  {'hex': '#E8DD21', 'name': '604'},
  {'hex': '#DDCE11', 'name': '605'},
  {'hex': '#D3BF11', 'name': '606'},
  {'hex': '#F2EABC', 'name': '607'},
  {'hex': '#EFE8AD', 'name': '608'},
  {'hex': '#EAE596', 'name': '609'},
  {'hex': '#E2DB72', 'name': '610'},
  {'hex': '#D6CE49', 'name': '611'},
  {'hex': '#C4BA00', 'name': '612'},
  {'hex': '#AFA00C', 'name': '613'},
  {'hex': '#EAE2B7', 'name': '614'},
  {'hex': '#E2DBAA', 'name': '615'},
  {'hex': '#DDD69B', 'name': '616'},
  {'hex': '#CCC47C', 'name': '617'},
  {'hex': '#B5AA59', 'name': '618'},
  {'hex': '#968C28', 'name': '619'},
  {'hex': '#847711', 'name': '620'},
  {'hex': '#D8DDCE', 'name': '621'},
  {'hex': '#C1D1BF', 'name': '622'},
  {'hex': '#A5BFAA', 'name': '623'},
  {'hex': '#7FA08C', 'name': '624'},
  {'hex': '#5B8772', 'name': '625'},
  {'hex': '#21543F', 'name': '626'},
  {'hex': '#0C3026', 'name': '627'},
  {'hex': '#CCE2DD', 'name': '628'},
  {'hex': '#B2D8D8', 'name': '629'},
  {'hex': '#8CCCD3', 'name': '630'},
  {'hex': '#54B7C6', 'name': '631'},
  {'hex': '#00A0BA', 'name': '632'},
  {'hex': '#007F99', 'name': '633'},
  {'hex': '#00667F', 'name': '634'},
  {'hex': '#BAE0E0', 'name': '635'},
  {'hex': '#99D6DD', 'name': '636'},
  {'hex': '#6BC9DB', 'name': '637'},
  {'hex': '#00B5D6', 'name': '638'},
  {'hex': '#00A0C4', 'name': '639'},
  {'hex': '#008CB2', 'name': '640'},
  {'hex': '#007AA5', 'name': '641'},
  {'hex': '#D1D8D8', 'name': '642'},
  {'hex': '#C6D1D6', 'name': '643'},
  {'hex': '#9BAFC4', 'name': '644'},
  {'hex': '#7796B2', 'name': '645'},
  {'hex': '#5E82A3', 'name': '646'},
  {'hex': '#26547C', 'name': '647'},
  {'hex': '#00305E', 'name': '648'},
  {'hex': '#D6D6D8', 'name': '649'},
  {'hex': '#BFC6D1', 'name': '650'},
  {'hex': '#9BAABF', 'name': '651'},
  {'hex': '#6D87A8', 'name': '652'},
  {'hex': '#335687', 'name': '653'},
  {'hex': '#0F2B5B', 'name': '654'},
  {'hex': '#0C1C47', 'name': '655'},
  {'hex': '#D6DBE0', 'name': '656'},
  {'hex': '#C1C9DD', 'name': '657'},
  {'hex': '#A5AFD6', 'name': '658'},
  {'hex': '#7F8CBF', 'name': '659'},
  {'hex': '#5960A8', 'name': '660'},
  {'hex': '#2D338E', 'name': '661'},
  {'hex': '#0C1975', 'name': '662'},
  {'hex': '#E2D3D6', 'name': '663'},
  {'hex': '#D8CCD1', 'name': '664'},
  {'hex': '#C6B5C4', 'name': '665'},
  {'hex': '#A893AD', 'name': '666'},
  {'hex': '#7F6689', 'name': '667'},
  {'hex': '#664975', 'name': '668'},
  {'hex': '#472B59', 'name': '669'},
  {'hex': '#F2D6D8', 'name': '670'},
  {'hex': '#EFC6D3', 'name': '671'},
  {'hex': '#EAAAC4', 'name': '672'},
  {'hex': '#E08CB2', 'name': '673'},
  {'hex': '#D36B9E', 'name': '674'},
  {'hex': '#BC3877', 'name': '675'},
  {'hex': '#A00054', 'name': '676'},
  {'hex': '#EDD6D6', 'name': '677'},
  {'hex': '#EACCCE', 'name': '678'},
  {'hex': '#E5BFC6', 'name': '679'},
  {'hex': '#D39EAF', 'name': '680'},
  {'hex': '#B7728E', 'name': '681'},
  {'hex': '#A05175', 'name': '682'},
  {'hex': '#7F284F', 'name': '683'},
  {'hex': '#EFCCCE', 'name': '684'},
  {'hex': '#EABFC4', 'name': '685'},
  {'hex': '#E0AABA', 'name': '686'},
  {'hex': '#C9899E', 'name': '687'},
  {'hex': '#B26684', 'name': '688'},
  {'hex': '#934266', 'name': '689'},
  {'hex': '#702342', 'name': '690'},
  {'hex': '#EFD1C9', 'name': '691'},
  {'hex': '#E8BFBA', 'name': '692'},
  {'hex': '#DBA8A5', 'name': '693'},
  {'hex': '#C98C8C', 'name': '694'},
  {'hex': '#B26B70', 'name': '695'},
  {'hex': '#8E4749', 'name': '696'},
  {'hex': '#7F383A', 'name': '697'},
  {'hex': '#F7D1CC', 'name': '698'},
  {'hex': '#F7BFBF', 'name': '699'},
  {'hex': '#F2A5AA', 'name': '700'},
  {'hex': '#E8878E', 'name': '701'},
  {'hex': '#D6606D', 'name': '702'},
  {'hex': '#B73844', 'name': '703'},
  {'hex': '#9E2828', 'name': '704'},
  {'hex': '#F9DDD6', 'name': '705'},
  {'hex': '#FCC9C6', 'name': '706'},
  {'hex': '#FCADAF', 'name': '707'},
  {'hex': '#F98E99', 'name': '708'},
  {'hex': '#F26877', 'name': '709'},
  {'hex': '#E04251', 'name': '710'},
  {'hex': '#D12D33', 'name': '711'},
  {'hex': '#FFD3AA', 'name': '712'},
  {'hex': '#F9C9A3', 'name': '713'},
  {'hex': '#F9BA82', 'name': '714'},
  {'hex': '#FC9E49', 'name': '715'},
  {'hex': '#F28411', 'name': '716'},
  {'hex': '#D36D00', 'name': '717'},
  {'hex': '#BF5B00', 'name': '718'},
  {'hex': '#F4D1AF', 'name': '719'},
  {'hex': '#EFC49E', 'name': '720'},
  {'hex': '#E8B282', 'name': '721'},
  {'hex': '#D18E54', 'name': '722'},
  {'hex': '#BA7530', 'name': '723'},
  {'hex': '#8E4905', 'name': '724'},
  {'hex': '#753802', 'name': '725'},
  {'hex': '#EDD3B5', 'name': '726'},
  {'hex': '#E2BF9B', 'name': '727'},
  {'hex': '#D3A87C', 'name': '728'},
  {'hex': '#C18E60', 'name': '729'},
  {'hex': '#AA753F', 'name': '730'},
  {'hex': '#723F0A', 'name': '731'},
  {'hex': '#60330A', 'name': '732'},
  {'hex': '#00AACC', 'name': '801'},
  {'hex': '#0089AF', 'name': '801 2X'},
  {'hex': '#60DD49', 'name': '802'},
  {'hex': '#1CCE28', 'name': '802 2X'},
  {'hex': '#FFED38', 'name': '803'},
  {'hex': '#FFD816', 'name': '803 2X'},
  {'hex': '#FF9338', 'name': '804'},
  {'hex': '#FF7F1E', 'name': '804 2X'},
  {'hex': '#F95951', 'name': '805'},
  {'hex': '#F93A2B', 'name': '805 2X'},
  {'hex': '#FF0093', 'name': '806'},
  {'hex': '#F7027C', 'name': '806 2X'},
  {'hex': '#D6009E', 'name': '807'},
  {'hex': '#BF008C', 'name': '807 2X'},
  {'hex': '#00B59B', 'name': '808'},
  {'hex': '#00A087', 'name': '808 2X'},
  {'hex': '#DDE00F', 'name': '809'},
  {'hex': '#D6D60C', 'name': '809 2X'},
  {'hex': '#FFCC1E', 'name': '810'},
  {'hex': '#FFBC21', 'name': '810 2X'},
  {'hex': '#FF7247', 'name': '811'},
  {'hex': '#FF5416', 'name': '811 2X'},
  {'hex': '#FC2366', 'name': '812'},
  {'hex': '#FC074F', 'name': '812 2X'},
  {'hex': '#E50099', 'name': '813'},
  {'hex': '#D10084', 'name': '813 2X'},
  {'hex': '#8C60C1', 'name': '814'},
  {'hex': '#703FAF', 'name': '814 2X'},
];

export default hexToPantone;
